import { render, staticRenderFns } from "./rosenbeet.vue?vue&type=template&id=821d52d8&scoped=true&"
import script from "./rosenbeet.vue?vue&type=script&lang=js&"
export * from "./rosenbeet.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "821d52d8",
  null
  
)

export default component.exports